import * as React from "react";
import { Table } from "antd";

const Report3DatesGrid = ({ dates }: { dates: string[] }) => {
  return (
    <Table
      bordered
      columns={[{ dataIndex: "date", key: "date" }]}
      dataSource={dates}
      pagination={false}
      showHeader={false}
      size={"small"}
    />
  );
};

export default Report3DatesGrid;
